/**
 * 记忆库术语库列表mixins
 */
import { getLang, getOptionList } from "@/services/memoryBank";
export default {
  data () {
    return {
      langList: {},
      optionList: {}
    }
  },
  methods: {
    async getLang () {
      const { success, result } = await getLang({ type: "1" })
      if (success) {
        this.langList = result;
      }
    },
    async getDomainList () {
      const { success, result } = await getOptionList({ dataType: "trans_domain" })
      if (success) {
        this.optionList = result;
      }
    },
  }
}